module.exports = __webpack_public_path__ + "static/media/embarque num sonho.e5491ab6.png";